// src/utils/authHelpers.js
import { jwtDecode } from "jwt-decode";

/**
 * Checks if the JWT token has expired.
 * @param {string} token - The JWT token.
 * @returns {boolean} - Returns true if expired, false otherwise.
 */
export const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const { exp } = jwtDecode(token);
    if (!exp) return true;

    const currentTime = Date.now() / 1000;
    return exp < currentTime;
  } catch (error) {
    console.error("Failed to decode token:", error);
    return true;
  }
};
